import {
    DeleteUnknownUserTemplateMutation,
    DeleteUnknownUserTemplateMutationVariables,
} from 'es/app/__generated__/global';
import { DELETE_UNKNOWN_USER_TEMPLATE } from 'es/app/views/system/sso-user-templates/graphql/system.deleteUnknownUserTemplate';
import ApolloProvider from 'es/core/net/ApolloProvider';

export async function deleteUnknownUserTemplate(id: DeleteUnknownUserTemplateMutationVariables['id']) {
    const { errors } = await ApolloProvider.system.mutate<
        DeleteUnknownUserTemplateMutation,
        DeleteUnknownUserTemplateMutationVariables
    >({
        mutation: DELETE_UNKNOWN_USER_TEMPLATE,
        variables: {
            id,
        },
    });
    if (errors) {
        throw new Error(`Failed to delete unknown user template with ID "${id}"`);
    }
    return id;
}
